jQuery(function ($) {
    "use strict";
    var hoverfold = $("#hoverfold");
    if (hoverfold.length != 0) {
        Modernizr.load({
            test: Modernizr.csstransforms3d && Modernizr.csstransitions,
            yep: ["//revcompsbicade.myshopify.com/cdn/shop/t/11/assets/jquery.hoverfold.js?v=126321430947183065451652559860"],
            nope: "css/fallback.css",
            callback: function (url, result, key) {
                if (url === "//revcompsbicade.myshopify.com/cdn/shop/t/11/assets/jquery.hoverfold.js?v=126321430947183065451652559860") $("#hoverfold div").hoverfold()
            }
        });
        var $container = hoverfold;
        $container.isotope();
        var $optionSets = jQuery(".filters-by-category .option-set"),
            $optionLinks = $optionSets.find("a");
        $optionLinks.click(function () {
            var $this = $(this);
            if ($this.hasClass("selected")) return false;
            var $optionSet = $this.parents(".option-set");
            $optionSet.find(".selected").removeClass("selected");
            $this.addClass("selected");
            var options = {},
                key = $optionSet.attr("data-option-key"),
                value = $this.attr("data-option-value");
            value = value === "false" ? false : value;
            options[key] = value;
            if (key === "layoutMode" && typeof changeLayoutMode === "function") changeLayoutMode($this, options);
            else $container.isotope(options);
            return false
        })
    }
});